import router from "../router";
import {dateStr2Times} from './TimeTransition'

/**
 * 把用户信息存放到vuex
 * @param result
 */
export function vuexUserData(result) {
  let user = {}
  user.userId = result.id
  user.userName = result.userName
  user.userToken = result.userToken
  user.userTypeEnum = result.userTypeEnum
  user.certificateStatus = result.certificateStatus
  user.userPhone = result.userPhone
  user.type = 1
  let localStorage = window.localStorage;
  if (localStorage) {
    localStorage.setItem('thesis-userToken', result.userToken);
  }
  router.app.$options.store.state.user = user;
  router.push({path: '/'})
}

/**
 * 把时间数据存放到vuex
 * @param result
 */
export function vuexTimeData(result) {
  let timeNetWork = result.timeNetWork
  router.app.$options.store.state.register_enter_oneContribute_startTime = dateStr2Times(timeNetWork[0].startTime)  //注册、报名、上传摘要开始时间
  router.app.$options.store.state.register_enter_oneContribute_endTime = dateStr2Times(timeNetWork[0].endTime) //注册、报名、上传摘要截止时间
  router.app.$options.store.state.oneContributeCheck_startTime = dateStr2Times(timeNetWork[1].startTime)//第一阶段投稿审核开始时间
  router.app.$options.store.state.oneContributeCheck_endTime = dateStr2Times(timeNetWork[1].endTime)//第一阶段投稿审核结束时间
  router.app.$options.store.state.twoContribute_startTime = dateStr2Times(timeNetWork[3].startTime)//第二阶段投稿开始时间
  router.app.$options.store.state.twoContribute_endTime = dateStr2Times(timeNetWork[3].endTime)//第二阶段投稿结束时间
  router.app.$options.store.state.twoContributeCheck_startTime = dateStr2Times(timeNetWork[4].startTime)//第二阶段投稿审核开始时间
  router.app.$options.store.state.twoContributeCheck_endTime = dateStr2Times(timeNetWork[4].endTime)//第二阶段投稿审核结束时间
  router.app.$options.store.state.threeContribute_startTime = dateStr2Times(timeNetWork[6].startTime)//第三阶段投稿开始时间
  router.app.$options.store.state.threeContribute_endTime = dateStr2Times(timeNetWork[6].endTime)//第三阶段投稿结束时间
  router.app.$options.store.state.reply_startTime = dateStr2Times(timeNetWork[7].startTime)//答辩开始时间
  router.app.$options.store.state.reply_endTime = dateStr2Times(timeNetWork[7].endTime)//答辩结束时间

  let curRound = result.gameRule.curRound  //轮数
  let certificate = result.gameRule.certificate
  let round1Submit = result.gameRule.round1Submit
  let round2Submit = result.gameRule.round2Submit
  let round3Submit = result.gameRule.round3Submit
  router.app.$options.store.state.curRound = curRound
  router.app.$options.store.state.certificate = certificate
  router.app.$options.store.state.round1Submit = round1Submit
  router.app.$options.store.state.round2Submit = round2Submit
  router.app.$options.store.state.round3Submit = round3Submit

  let newsNotice = result.newsNotice
  for (let i = 0; i < newsNotice.length; i++) {
    newsNotice[i].issueTime = dateStr2Times(newsNotice[i].issueTime)
    newsNotice[i].sourceFrom = i+1
  }
  router.app.$options.store.state.newsNotice = newsNotice

  let data = []
  if(newsNotice.length>10){
    for(let i = 0; i < 10; i++){
      data.push(newsNotice[i])
    }
  }else{
    data = newsNotice;
  }

  router.app.$options.store.state.newsNotice1 = data

}



// WEBPACK FOOTER //
// ./src/util/vuexData.js